import { render, staticRenderFns } from "./wtBrandsDropdown.vue?vue&type=template&id=17143ea6&scoped=true&"
import script from "./wtBrandsDropdown.vue?vue&type=script&lang=js&"
export * from "./wtBrandsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17143ea6",
  null
  
)

export default component.exports